module.exports = __webpack_public_path__ + "static/umberlee-DND3_FnP-5b0580584d15d780a82792b9cb731a57.jpg";